import { MS_API_PREFIX } from '@/addons/mailService/config/constants';
import { MSErrorResponse } from '@/addons/mailService/types/common';
import { SCHEDULER_API_URL } from '@/addons/scheduler/config/constants';
import { IErrorResponse } from '@/shared/types/api';
import { FetchArgs } from '@reduxjs/toolkit/dist/query/react';

import { omit, upperFirst } from 'lodash';

const adjustSSchedulerParams = (params?: Record<string, any>) => {
  if (!params || typeof params !== 'object') return params;

  const adjustedParams: Record<string, any> = {};

  Object.keys(params).forEach((key) => {
    if (key === 'size') {
      adjustedParams.limit = params.size;
    }

    if (key === 'sortBy' && params.sortBy) {
      adjustedParams[`sortBy${upperFirst(params.sortBy)}`] = params.sortType;
    }
  });

  return { ...omit(params, 'size', 'sortType', 'sortBy'), ...adjustedParams };
};

const isAddonsApi = (args: string | FetchArgs) =>
  typeof args !== 'string' && (args.url.startsWith(String(MS_API_PREFIX)) || args.url.startsWith(String(SCHEDULER_API_URL)));

export const getNormalizedArgs = (args: string | FetchArgs) => {
  if (typeof args === 'string') return args;

  const normalizedArgs: FetchArgs = {
    ...args,
    params: args.params ? { ...args.params } : args.params,
  };

  if (isAddonsApi(normalizedArgs)) {
    normalizedArgs.params = adjustSSchedulerParams(normalizedArgs.params);
  }

  return normalizedArgs;
};

export const getErrorText = (args: string | FetchArgs, error?: IErrorResponse & MSErrorResponse) => {
  if (isAddonsApi(args)) {
    return JSON.stringify(error?.data?.errors || error?.data, null, 2);
  }

  return JSON.stringify(error?.data?.report, null, 2)
    ?.replace(/[",`():{}[\]]/g, '')
    ?.replace('...', 'any valid');
};
